import React from "react";
import { Route, Redirect } from "react-router-dom";

import useAuth from "../../../customHooks/useAuth";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { loadingAuth, isAuth } = useAuth();
  if (loadingAuth) {
    return <></>;
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default ProtectedRoute;
